import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { fetchPartJson } from "#modules/parts/infra/fetchPartJson.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const partJsonQuery = (id: string | undefined) => ({
  queryKey: queryKeys.parts.json(id),
  queryFn: () => fetchPartJson(id!),
  staleTime: STALE_TIME,
  enabled: !!id,
});
